module.exports = __webpack_public_path__ + "static/img/jzsq.2f9e7987.png";